var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"submit-button",class:_vm.loadingClass,on:{"mouseenter":_vm.hoverEvent,"mouseleave":_vm.hoverEvent}},[_c('AppButton',_vm._g(_vm._b({attrs:{"primary":""}},'AppButton',_vm.$attrs,false),_vm.$listeners),[(_vm.loading)?_c('Spinner',{attrs:{"size":_vm.spinnerSize,"color":_vm.spinnerColor}}):[_vm._t("default")]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }